import { render, staticRenderFns } from "./Framablog.vue?vue&type=template&id=1efc1f38"
import script from "./Framablog.vue?vue&type=script&lang=js"
export * from "./Framablog.vue?vue&type=script&lang=js"
import style0 from "./Framablog.vue?vue&type=style&index=0&id=1efc1f38&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports